import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import '../Box/Box.js';
import 'react';
import 'reakit-utils/useLiveRef';
import 'reakit-utils/useSealedState';
import '../Id/IdProvider.js';
import '../Id/IdState.js';
import { useGroup } from '../Group/Group.js';
import 'reakit-utils/useUpdateEffect';
import 'reakit-utils/isPromise';
import 'reakit-utils/isEmpty';
import 'reakit-utils/isPlainObject';
import { unstable_useFormState } from './FormState.js';
import 'reakit-utils/isObject';
import './utils/setAllIn.js';
import './utils/getIn.js';
import 'reakit-utils/toArray';
import 'reakit-utils/isInteger';
import './utils/setIn.js';
import { g as getInputId } from '../getInputId-aa144169.js';
import { g as getLabelId } from '../getLabelId-3db05e97.js';
import { g as getMessageId, s as shouldShowError } from '../shouldShowError-62b18bba.js';

var unstable_useFormGroup = createHook({
  name: "FormGroup",
  compose: useGroup,
  useState: unstable_useFormState,
  keys: ["name"],
  useProps: function useProps(options, htmlProps) {
    return _objectSpread2({
      id: getInputId(options.name, options.baseId),
      tabIndex: -1,
      "aria-describedby": getMessageId(options.name, options.baseId),
      "aria-labelledby": getLabelId(options.name, options.baseId),
      "aria-invalid": shouldShowError(options, options.name)
    }, htmlProps);
  }
});
var unstable_FormGroup = createComponent({
  as: "fieldset",
  useHook: unstable_useFormGroup
});

export { unstable_FormGroup, unstable_useFormGroup };
